export default __webpack_public_path__ + "img/btn-delete.7bbf4778.svg";